import { graphql } from "@/lib/gql/__generated__";

export const SelectHotelTemplateQuery = graphql(/* GraphQL */ `
	query SelectHotelTemplate($hotelID: ID!) {
		hotelTemplateSettings(hotelID: $hotelID) {
			id
			hotelID
			hotelTemplateType
			hotelTemplateTypeSelectable
		}
	}
`);
